import _ from "lodash";
import EventImagePreview from "@/components/Events/EventImagePreview/EventImagePreview.vue";
import "./EventMedia.scss";
import {
  getImageDimensionSizes,
  generateImageFromPdf
} from "@/helpers/commonHelper";
import { uploadFile } from "@/helpers/fileHelper";
import InfoDialog from "@/components/Common/InfoDialog/InfoDialog.vue";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import EventFilePreview from "@/components/Events/EventFilePreview/EventFilePreview.vue";

export default {
  name: "EventMedia",
  props: [
    "editedEvent",
    "step",
    "position",
    "isOwnedBySubPrincipal",
    "channels"
  ],
  components: { EventFilePreview, InfoDialog, EventImagePreview },
  data: () => ({
    mainDragging: false,
    fileDragging: false,
    preventMainWatch: false,
    preventFileWatch: false
  }),
  methods: {
    generateImageFromPdf,
    async addDropFile(e, type) {
      if (!Array.isArray(this[`${type}Files`])) this[`${type}Files`] = [];
      const files = e?.dataTransfer?.files ?? e ?? [];
      await Array.from(files).asyncForEach(async file => {
        const isPdfFile = file.type.toLowerCase() === "application/pdf";

        const data = await uploadFile(
          file,
          undefined,
          "events",
          this.selectedPrincipal.id,
          progressEvent => {
            this.$store.dispatch(
              "createSuccess",
              Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                " % hochgeladen.."
            );
          }
        );

        file.id = data.id;
        file.locked = data.locked;

        if (type === "main" && !data.imageSizes && data.url) {
          data.image_sizes = await getImageDimensionSizes(data.url);
        } else if (isPdfFile) {
          const generatedPdfPicture = await this.generateImageFromPdf(
            data.url,
            data.title.replace(".pdf", "")
          );
          data.picture = await uploadFile(
            generatedPdfPicture,
            this.editedEvent.id || this.editedEvent._id,
            "events",
            this.selectedPrincipal.id,
            progressEvent => {
              this.$store.dispatch(
                "createSuccess",
                Math.round((progressEvent.loaded * 100) / progressEvent.total) +
                  " % Bild aus PDF generiert ..."
              );
            }
          );
          data.picture.principal_id = this.selectedPrincipal.id;
        }
        data.principal_id = this.selectedPrincipal.id;

        data.title = file.name;
        data.channels = [...this.channels.map(c => c.value)];
        if (type === "main") {
          data.fit_cover = true;
        }

        this[`${type}Files`].push(data);
        this.$emit("save", false);
      });
    },
    setMainFiles(newVal) {
      const order = newVal.map(v => v.id);
      this.preventMainWatch = true;
      this.mainFiles = _.sortBy(this.mainFiles, file => {
        return _.indexOf(order, file.id);
      });
    },
    async removeFile(id, type) {
      const isConfirmed = await this.$confirm(
        "Wollen Sie die Datei und das eventuell dazugehörige Bild wirklich löschen?",
        confirmWarningConfig
      );
      if (!isConfirmed) {
        return;
      }
      this.$emit("addToDestroyList", id);
      if (type === "file") {
        const picture = this[`${type}Files`].find(f => f.id === id)?.picture;
        if (picture?._id) {
          this.$emit("addToDestroyList", picture._id);
        }
      }
      const index = this[`${type}Files`].findIndex(f => f.url.includes(id));
      this[`${type}Files`].splice(index, 1);
    },
    clear() {
      this.mainDialog = false;
      this.logoDialog = false;
      this.mainDragging = false;
      this.fileDragging = false;
      this.logoDragging = false;
      this.preventMainWatch = false;
      this.preventFileWatch = false;
      this.preventLogoWatch = false;

      this.mainFiles.splice(0, this.mainFiles.length);
      this.fileFiles.splice(0, this.fileFiles.length);
    },
    readFileUrls(files, type) {
      this[`${type}Dragging`] = false;
      this[`${type}Files`].forEach(file => {
        if (!file.id) {
          const reader = new FileReader();
          reader.onload = event => {
            const target = event.target;
            if (target?.result) {
              file.originalUrl = target.result;
              file.dataUrl = target.result;
            }
          };
          reader.readAsDataURL(file);
        }
      });
    }
  },
  computed: {
    mainFiles: {
      get() {
        return this.editedEvent?.pictures ?? [];
      },
      set(value) {
        this.editedEvent.pictures = value;
      }
    },
    fileFiles: {
      get() {
        return this.editedEvent?.files ?? [];
      },
      set(value) {
        this.editedEvent.files = value;
      }
    },
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  },
  watch: {
    mainFiles(val) {
      if (!this.preventMainWatch) {
        this.readFileUrls(val, "main");
      } else this.preventMainWatch = false;
    },
    fileFiles(val) {
      if (!this.preventFileWatch) {
        this.readFileUrls(val, "file");
      } else this.preventFileWatch = false;
    }
  }
};
